import { callFetch } from './serviceHelpers';

export const getFulfillers = (accessToken, env) =>
  callFetch('fulfillerIdentityUrl', 'GET', 'v1/fulfillers', null, accessToken, env).then(response =>
    response.map(v => ({ name: v.name, fulfillerId: v.fulfillerId, internalFulfillerId: v.internalFulfillerId }))
  );
